import IField from "@/interfaces/IField";
import ISection from "@/interfaces/ISection";

/** Section de formulaire */
export default class Section<T = any, F= IField[]> implements ISection<T, F> {
	private _name: string;
	private _label: string;
	private _fields: F;
	private _visible: boolean;
	private _value?: T;

	constructor();
	constructor(name: string, label: string, fields: F, visible: boolean);
	constructor(name: string, label: string, fields: F, visible: boolean, value?: T)
	constructor(name: string = "", label: string = "", fields: F = {} as F, visible: boolean = false, value?: T) {
		this._name = name;
		this._label = label;
		this._fields = fields;
		this._visible = visible;
		this._value = value;
	}

	/** Nom */
	public get Name(): string {
		return this._name;
	}

	/** Nom */
	public set Name(value: string) {
		this._name = value;
	}

	/** Libellé */
	public get Label(): string {
		return this._label;
	}

	/** Libellé */
	public set Label(value: string) {
		this._label = value;
	}

	/** Liste des champs contenu dans la section */
	public get Fields(): F {
		return this._fields;
	}

	/** Liste des champs contenu dans la section */
	public set Fields(value: F) {
		this._fields = value;
	}

	/** Indique si la section est visible ou non */
	public get Visible(): boolean {
		return this._visible;
	}

	/** Indique si la section est visible ou non */
	public set Visible(value: boolean) {
		this._visible = value;
	}

	/** Données complémentaires */
	public get Value(): T {
		return this._value;
	}

	/** Données complémentaires */
	public set Value(value: T) {
		this._value = value;
	}
}